import React from 'react';
import { propTypes, withFormsy } from 'formsy-react';
import _ from 'lodash';
import { InputLabel, Select, MenuItem, FormHelperText } from '@material-ui/core';

export class SelectInput extends React.Component {
  constructor(props) {
    super(props);

    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    const { onChange, setValue } = this.props;
    if (onChange) onChange(event);
    setValue(event.target.value);
  }

  render() {
    const { name, label, options, disabled, placeholder, hint, value, errorMessage, isPristine } = this.props;
    const isError = !isPristine && errorMessage != null;

    return (
      <div className="input-container">
        <InputLabel htmlFor={name} error={isError}>{label}</InputLabel>
        <Select
          error={isError}
          id={name}
          name={name}
          onChange={this.changeValue}
          value={value || ''}
          disabled={disabled}
          displayEmpty
          fullWidth
        >
          <MenuItem value="" disabled>{placeholder}</MenuItem>
          {options.map((option, i) => (
            _.isObject(option) ?
              <MenuItem key={i} value={option.value}>{option.label}</MenuItem>
            :
              <MenuItem key={i} value={option}>{option}</MenuItem>
          ))}
        </Select>
        {!isPristine && errorMessage &&
          <FormHelperText error={isError}>{errorMessage}</FormHelperText>
        }
        {hint &&
          <FormHelperText>{hint}</FormHelperText>
        }
      </div>
    );
  }
}

SelectInput.propTypes = {
  ...propTypes
};

export default withFormsy(SelectInput);
